<template lang="pug">
  component(:is="tag" :href="path")
    slot
</template>

<script>
export default {
  name: 'reload-router-link',

  props: {
    to: {
      type: Object,
      required: true,
    },
    tag: {
      type: String,
      default: 'a',
    },
  },
  
  data: () => ({
    path: null,
  }),

  created() {
    const route = this.$router.match(this.to)
    this.path = route.fullPath;
  }
}
</script>
